import { forwardRef, MouseEventHandler } from "react";
import { Button, ButtonProps, Spinner } from "react-bootstrap";
import { Icon } from "../graphic/Icons";

type LoadingButtonProps = {
  block?: boolean;
  containerClassName?: string;
  variant?: string;
  disabled?: boolean;
  isLoading?: boolean;
  isWarning?: boolean;
  circle?: boolean;
  className?: string;
  children?: React.ReactNode;
    onClick? : MouseEventHandler,
} & ButtonProps;

const CoreButton = forwardRef<HTMLButtonElement, LoadingButtonProps>(
  (
    {
      block,
      containerClassName,
      variant,
      disabled,
      isLoading,
      isWarning,
      circle,
      className,
      children,
      ...childProps
    },
    ref
  ) => {
    return (
      <div
        className={`${block ? "d-grid " : ""}${
          containerClassName ? containerClassName : ""
        }`}
      >
        <Button
          {...childProps}
          ref={ref}
          variant={variant}
          disabled={isLoading || disabled}
          className={`btn-loading justify-content-center ${
            circle ? "px-1 py-1 rounded-circle" : !isLoading ? "px-3" : "px-2"
          } ${className ?? ""}`}
        >
          {isLoading && (
            <>
              <Spinner size="sm" /> <span />
            </>
          )}
          {isWarning && (
            <Icon
              name="BsExclamationDiamond"
              size="14"
              className="mx-2"
            />
          )}
          {children}
        </Button>
      </div>
    );
  }
);

export default CoreButton;
